import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ContractVehicles } from '../components/ContractVehicles';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function ContractVehiclesPage() {
  return <div className="w-full" data-id="element-1183" data-mp="34c16k8aou32u">
      {/* HERO SECTION */}
      <section className="section-navy hero-grid-pattern" data-id="element-1184" data-mp="2gkvum47vbuxt">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15 text-center" data-id="element-1185" data-mp="2gjawy5q9bvvq">
          <motion.div initial="hidden" animate="visible" variants={fadeIn} data-id="element-1186" data-mp="2bkhjgdaz04vk">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-tight max-w-4xl mx-auto" data-id="element-1187" data-mp="2pesaj1afwb4s">
              Contract Vehicles
            </h1>
            <div className="h-1.5 w-24 bg-nrs-orange mx-auto rounded-full mb-6" data-id="element-1188" data-mp="1wxocbvblu5eg"></div>
            <p className="text-xl text-nrs-light font-bold max-w-2xl mx-auto" data-id="element-1189" data-mp="1wvblstrs6mps">
              New River Systems holds multiple contract vehicles to streamline
              procurement for federal clients.
            </p>
          </motion.div>
        </div>
      </section>

      {/* CONTRACT VEHICLES */}
      <section className="section-white" data-id="element-1190" data-mp="1s4gebmwu80hb">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15" data-id="element-1191" data-mp="1wyklo7a0maix">
          <ContractVehicles data-id="element-1192" data-mp="21wcnbt0gpb0b" />

          <div className="max-w-3xl mx-auto bg-nrs-light p-6 rounded-md text-sm text-nrs-gray grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1193" data-mp="21vks4jas1fak">
            <div data-id="element-1194" data-mp="14ayk14kclfyp">
              <p className="mb-2" data-id="element-1195" data-mp="197yppedacgpa">
                <span className="font-bold text-nrs-navy" data-id="element-1196" data-mp="199015jy7r57j">Primary NAICS:</span>{' '}
                541519 - Other Computer Related Services
              </p>
              <p className="mb-2" data-id="element-1197" data-mp="1e9e7mxk6273g">
                <span className="font-bold text-nrs-navy" data-id="element-1198" data-mp="1j6ef9cwnzhwo">
                  Other Associated NAICS:
                </span>{' '}
                518210, 511199
              </p>
              <p data-id="element-1199" data-mp="2ul1i7aaxck3m">
                <span className="font-bold text-nrs-navy" data-id="element-1200" data-mp="2uki8ggvfh20o">
                  Business Classifications:
                </span>{' '}
                SBA Certified Service-Disabled Veteran Owned Small Business
              </p>
            </div>
            <div data-id="element-1201" data-mp="pjpe2x9jrvrh">
              <p className="mb-2" data-id="element-1202" data-mp="pmbg6hdo5j2b">
                <span className="font-bold text-nrs-navy" data-id="element-1203" data-mp="13k03dvv7l2aj">CAGE Code:</span>{' '}
                4RNU2
              </p>
              <p className="mb-2" data-id="element-1204" data-mp="zjg7swqaa6qi">
                <span className="font-bold text-nrs-navy" data-id="element-1205" data-mp="zgahje5x4yt7">UEI:</span>{' '}
                DWT1XD8JT8M4
              </p>
              <p className="mb-2" data-id="element-1206" data-mp="6tpqketcuoq6">
                <span className="font-bold text-nrs-navy" data-id="element-1207" data-mp="6uis91dgio1g">DUNS:</span> 799154450
              </p>
              <p data-id="element-1208" data-mp="klw4rvcy6lmz">
                <span className="font-bold text-nrs-navy" data-id="element-1209" data-mp="kmfcykcspvnt">SAM Registered:</span>{' '}
                Active
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-light-blue" data-id="element-1210" data-mp="3o84mwh1rx14b">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15 text-center" data-id="element-1211" data-mp="3k8vtjdanb59a">
          <h3 className="text-2xl font-bold mb-8" data-id="element-1212" data-mp="3a4ffmpgq7y84">
            Ready to Work with New River Systems?
          </h3>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1213" data-mp="3evnp1li23jla">
            <Link to="/contact-us" className="btn-primary" data-id="element-1214" data-mp="3069e48yu0u3s">
              Contact Business Development
            </Link>
            <Link to="/about-us/certifications" className="btn-secondary" data-id="element-1215" data-mp="354t0gahc87wo">
              View Our Certifications
            </Link>
          </div>
        </div>
      </section>
    </div>;
}